import { useEffect, CSSProperties, useState } from "react";

const getCssProperties = (header: any) => {
    const styles = {};

    if (header?.backgroundColor) {
        styles["--header-background-color"] = header.backgroundColor;
    }

    // Anchor

    if (header?.anchorColor) {
        styles["--header-anchor-text-color"] = header.anchorColor;
    }

    if (header?.hoverAnchorColor) {
        styles["--header-anchor-hover-text-color"] = header.hoverAnchorColor;
    }

    // Mobile Overlay

    if (header?.overlayBackgroundColor) {
        styles["--menu-overlay-background-color"] = header.overlayBackgroundColor;
    }

    if (header?.overlayAnchorColor) {
        styles["--menu-overlay-anchor-color"] = header.overlayAnchorColor;
    }

    if (header?.overlayBorderColor) {
        styles["--menu-overlay-border-color"] = header.overlayBorderColor;
    }

    if (header?.overlayCloseColor) {
        styles["--menu-overlay-close-color"] = header.overlayCloseColor;
    }

    // Search Overlay

    if (header?.searchBackgroundColor) {
        styles["--search-background-color"] = header.searchBackgroundColor;
    }

    if (header?.searchBorderColor) {
        styles["--search-border-color"] = header.searchBorderColor;
    }

    if (header?.searchAnchorTextColor) {
        styles["--search-anchor-text-color"] = header.searchAnchorTextColor;
    }

    if (header?.searchHoverAnchorTextColor) {
        styles["--search-anchor-hover-text-color"] = header.searchHoverAnchorTextColor;
    }

    return styles;
};

export default (header?: any): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(header));

    useEffect(() => {
        setResult(getCssProperties(header));
    }, [header]);

    return result;
};